// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
import SegmentConstants from 'constants/SegmentConstants'
import { isSegmentHidden } from 'utils/SegmentSelectHelper'

const SegmentStore = Marty.createStore({
  id: 'SegmentStore',

  getInitialState() {
    return {
      // TODO each request should have its own status
      // overloading this map so when the request is done, the state is the segmentId
      requestIdToState: {},
      requestIdToSegmentId: {},
      createSegmentStatus: undefined,
      segmentsById: {},
      elasticSearchMembersBySegmentId: {},
      activeCampaignsBySegmentId: {}
    }
  },

  handlers: {
    createSegmentStarting: SegmentConstants.SEGMENT_CREATE_STARTING,
    createSegmentFailed: SegmentConstants.SEGMENT_CREATE_FAILED,
    createSegmentDone: SegmentConstants.SEGMENT_CREATE_DONE,

    fetchSegmentsDone: SegmentConstants.SEGMENTS_FETCH_DONE,
    fetchSegmentDone: SegmentConstants.SEGMENT_FETCH_DONE,
    elasticSearchMembersDone: SegmentConstants.SEGMENT_ELASTIC_SEARCH_MEMBERS_DONE,

    deleteSegmentDone: SegmentConstants.DELETE_SEGMENT_DONE,

    handleSegmentAddMembers: SegmentConstants.SEGMENT_ADD_MEMBERS_DONE,
    handleSegmentDeleteMembers: SegmentConstants.SEGMENT_DELETE_MEMBERS_DONE,

    fetchCampaignsForSegmentDone: SegmentConstants.GET_CAMPAIGNS_FOR_SEGMENT_DONE
  },

  getOrFetchSegments() {
    return this.fetch({
      id: 'getOrFetchSegments',

      locally() {
        if (this.hasAlreadyFetched('getOrFetchSegments')) {
          const segments = _.values(this.state.segmentsById)
          return _.orderBy(segments, 'createdAt', 'desc')
        }
      },

      remotely() {
        return this.app.queries.SegmentQueries.fetchSegments()
      }
    })
  },

  fetchEnabledSegments() {
    return this.fetch({
      id: 'fetchEnabledSegments',
      dependsOn: [this.getOrFetchSegments()],
      locally() {
        return _.filter(this.state.segmentsById, segment => !isSegmentHidden(segment))
      }
    })
  },

  fetchEnabledSegmentsGroupedByType() {
    return this.fetch({
      id: 'fetchEnabledSegmentsGroupedByType',
      dependsOn: [this.getOrFetchSegments()],
      locally() {
        const segments = _.filter(this.state.segmentsById, segment => !isSegmentHidden(segment))
        return _.groupBy(segments, 'type')
      }
    })
  },

  fetchEnabledSegmentsByName() {
    return this.fetch({
      id: 'fetchEnabledSegmentsByName',
      dependsOn: [this.getOrFetchSegments()],
      locally() {
        const enabledSegments = _.filter(this.state.segmentsById, segment => !isSegmentHidden(segment))
        return _.keyBy(enabledSegments, 'name')
      }
    })
  },

  fetchStaticSegments() {
    return this.fetch({
      id: 'fetchStaticSegments',
      dependsOn: [this.getOrFetchSegments()],
      locally() {
        return _.filter(this.state.segmentsById, segment => (segment.type === 'ID_LIST') && !isSegmentHidden(segment))
      }
    })
  },

  getOrFetchSegment(segmentId) {
    return this.fetch({
      id: `getOrFetchSegment${ segmentId }`,

      locally() {
        return this.state.segmentsById[segmentId]
      },

      remotely() {
        return this.app.queries.SegmentQueries.fetchSegment(segmentId)
      }
    })
  },

  fetchCampaignsForSegment(segmentId) {
    return this.fetch({
      id: `fetchCampaignsForSegment${ segmentId }`,
      locally() {
        return this.state.activeCampaignsBySegmentId[segmentId]
      },
      remotely() {
        return this.app.queries.SegmentQueries.getCampaignsForSegment(segmentId)
      }
    })
  },

  fetchCampaignsForSegmentDone(segmentId, campaigns) {
    const activeCampaignsBySegmentId = _.cloneDeep(this.state.activeCampaignsBySegmentId)
    activeCampaignsBySegmentId[segmentId] = campaigns
    return this.setState({ activeCampaignsBySegmentId })
  },

  getCreateSegmentStatus() { return this.state.createSegmentStatus },

  getLastSegmentCreated() { return this.state.lastSegmentCreated },

  createSegmentStarting(requestId) {
    const requestIdToState = _.cloneDeep(this.state.requestIdToState)
    requestIdToState[requestId] = SegmentConstants.SEGMENT_CREATE_STARTING
    return this.setState({
      requestIdToState,
      createSegmentStatus: SegmentConstants.SEGMENT_CREATE_STARTING
    })
  },

  createSegmentFailed(requestId) {
    const requestIdToState = _.cloneDeep(this.state.requestIdToState)
    requestIdToState[requestId] = SegmentConstants.SEGMENT_CREATE_FAILED
    return this.setState({
      requestIdToState,
      createSegmentStatus: SegmentConstants.SEGMENT_CREATE_FAILED
    })
  },

  fetchSegmentDone(segmentId, segment) {
    const segmentsById = _.cloneDeep(this.state.segmentsById)
    segmentsById[segmentId] = segment
    return this.setState({ segmentsById })
  },

  deleteSegmentDone(segmentId) {
    const segmentsById = _.cloneDeep(this.state.segmentsById)
    delete segmentsById[segmentId]
    return this.setState({ segmentsById })
  },

  fetchSegmentsDone(segments) {
    const segmentsById = _.cloneDeep(this.state.segmentsById)
    _.each(segments, segment => segmentsById[segment.id] = segment)
    return this.setState({ segmentsById })
  },

  createSegmentDone(requestId, segment) {
    const segmentsById = _.cloneDeep(this.state.segmentsById)
    segmentsById[segment.id] = segment
    const requestIdToState = _.cloneDeep(this.state.requestIdToState)
    requestIdToState[requestId] = segment.id
    return this.setState({
      segmentsById,
      requestIdToState,
      createSegmentStatus: SegmentConstants.SEGMENT_CREATE_DONE,
      lastSegmentCreated: segment
    })
  },

  getRequestIdToState() {
    return this.state.requestIdToState
  },

  getSegmentsById() {
    return this.state.segmentsById
  },

  resetCreationState() {
    return this.setState({
      createSegmentStatus: undefined,
      lastSegmentCreated: undefined
    })
  },

  elasticSearchMembersOfSegment(segmentId, from, size) {
    const fetchId = `elasticSearchMembersOfSegment${ segmentId }[${from}-${size}]`
    return this.fetch({
      id: fetchId,
      locally() {
        const membersForSegmentId = this.state.elasticSearchMembersBySegmentId[segmentId]
        if (membersForSegmentId) {
          return membersForSegmentId[this.generateElasticSearchCacheId(from, size)]
        }
      },
      remotely() {
        return this.app.queries.SegmentQueries.elasticSearchMembersOfSegment(segmentId, from, size)
      }
    })
  },

  generateElasticSearchCacheId(from, size) {
    const sizeQuery = {}
    if (from != null) { sizeQuery.from = from }
    if (size != null) { sizeQuery.size = size }
    return JSON.stringify(sizeQuery)
  },

  handleSegmentAddMembers(segmentId) {
    return this.resetElasticSearchMembersForSegment(segmentId)
  },

  handleSegmentDeleteMembers(segmentId) {
    return this.resetElasticSearchMembersForSegment(segmentId)
  },

  resetElasticSearchMembersForSegment(segmentId) {
    const elasticSearchMembersBySegmentId = _.cloneDeep(this.state.elasticSearchMembersBySegmentId)
    delete elasticSearchMembersBySegmentId[segmentId]
    return this.setState({ elasticSearchMembersBySegmentId })
  },

  elasticSearchMembersDone(segmentId, from, size, searchResult) {
    const elasticSearchMembersBySegmentId = _.cloneDeep(this.state.elasticSearchMembersBySegmentId)
    if (!elasticSearchMembersBySegmentId[segmentId]) {
      elasticSearchMembersBySegmentId[segmentId] = {}
    }

    elasticSearchMembersBySegmentId[segmentId][this.generateElasticSearchCacheId(from, size)] = searchResult
    return this.setState({ elasticSearchMembersBySegmentId })
  }
})

export default SegmentStore



// WEBPACK FOOTER //
// ./src/scripts/stores/SegmentStore.js